import React from 'react';
import Seo from '../../components/utils/Seo';
import BodyError from './body/BodyError'

function Error404(props) {
    return (
        <div className="selection:bg-primary selection:text-white">
            <Seo
                title="Erreur 404 | veuillez retourner à la page d'accueil"
                description="Rita nsangou est la solution pour tout vos problèmes de traduction. français-anglais-espagnol"
            />
            <BodyError />
        </div>
    );
}

export default Error404;